import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill="none">
      <path
        fill="#D80000"
        d="M17 20h3a2 2 0 002-2V5a1 1 0 00-1-1H11a1 1 0 00-1 1v14a1 1 0 001 1h1v-3.5a1.5 1.5 0 013 0V18a2 2 0 002 2z"
      />
      <g fill="#051045">
        <path d="M11.8 19a.8.8 0 01.794.7l.006.1c0 .246.064.486.183.692l.078.12 1.129 1.54c.36.495.562.88.602 1.335l.008.174V27.8a.8.8 0 01-1.594.1L13 27.8v-4.14c0-.079-.068-.227-.23-.463l-1.2-1.64A2.976 2.976 0 0111 19.8a.8.8 0 01.8-.8zm8 .6c.408 0 .744.26.794.594l.006.085v7.642c0 .375-.358.679-.8.679-.408 0-.744-.26-.794-.594L19 27.921v-7.642c0-.375.358-.679.8-.679z" />
        <path d="M19.8 3h-8A2.8 2.8 0 009 5.8v12a2.8 2.8 0 002.592 2.792l1.008.038V16.3a.7.7 0 011.4 0v1.5a2.8 2.8 0 002.8 2.8h3a2.8 2.8 0 002.8-2.8v-12A2.8 2.8 0 0019.8 3zm-8 1.6h8A1.2 1.2 0 0121 5.8v12a1.2 1.2 0 01-1.2 1.2h-3a1.2 1.2 0 01-1.2-1.2v-1.5a2.3 2.3 0 00-2.3-2.3l-.157.005A2.3 2.3 0 0011 16.3v2.398l-.042-.04a1.212 1.212 0 01-.358-.858v-12a1.2 1.2 0 011.2-1.2z" />
      </g>
    </g>
  </svg>
);

const IconRedCard = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconRedCard;
